import React, { useEffect, useState } from 'react'
import Base from '../../Base';
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import '../../../App.css';
import Api from '../../Services/ApiCall';
import Swal from 'sweetalert2';

export default function Schemeform() {



    const location = useLocation();
    const { ID, Flag } = location.state;

    const navigate = useNavigate();
    const [schemename, setschemename] = useState("");
    const [schemedate, setschemedate] = useState("");
    const [schemeenddate, setschemeenddate] = useState("");
    const [schememonth, setschememonth] = useState("");
    const [schemecertificate, setschemecertificate] = useState("");

    async function IUDOperation() {

        if (schemename == "") {
            toast.error('Please enter Scheme Name')
            return false;
        }
        if (schemedate == "") {
            toast.error('Please enter Scheme Start Date')
            return false;
        }
        if (schemeenddate == "") {
            toast.error('Please enter Scheme End Date')
            return false;
        }
        if (schememonth == "") {
            toast.error('Please enter Number of Months')
            return false;
        }
        if (schemecertificate == "") {
            toast.error('Please enter Number of Certificate')
            return false;
        }
        

        var Param = {
            "mstSchememasterId": ID,
            "schememasterCode": "",
            "schemename": schemename,
            "schemestartdate": schemedate,
            "schemeenddate": schemeenddate,
            "schememonths": schememonth,
            "schemecertificates": schemecertificate,
            "flag": Flag,
            "active": "",
            "searchField": "",

        };
        var url = "/CommanAPI/CreateScheme";
        let _response = await Api.IUD(Param, url);
        showAlert(_response.Messages);
        setTimeout(() => {
            navigate('/Scheme')
        }, 1000)

    }
    const showAlert = (_response) => {
        Swal.fire({
            title: "Success",
            text: _response,
            icon: "success",
            confirmButtonText: "OK",
        });
    };


    return (
        <div>
            <Toaster toastOptions={{ position: "top-right" }} />
            <Base Scheme={true} />
            <div id="main" class="main">
                <div class="pagetitle">

                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dash">Home</Link></li>
                            <li class="breadcrumb-item">General Setting</li>
                            <li class="breadcrumb-item active">Scheme Creation</li>
                        </ol>
                    </nav>
                </div>

                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Scheme  Creation</h5>


                        <div class="row g-3">
                            <div class="col-md-4">
                                <label for="name">Scheme name</label>
                                <input type="text" class="form-control" placeholder="Enter Scheme Name" value={schemename} onChange={(e) => setschemename(e.target.value)} />
                            </div>

                            <div class="col-md-4">
                                <label for="sDate">Scheme Start Date</label>
                                <input type="date" class="form-control" placeholder="Enter Scheme Start Date" value={schemedate} onChange={(e) => setschemedate(e.target.value)} />
                            </div>

                            <div class="col-md-4">
                                <label for="eDate">Scheme End Date</label>
                                <input type="date" class="form-control" placeholder="Enter Scheme End Date" value={schemeenddate} onChange={(e) => setschemeenddate(e.target.value)} />
                            </div>

                            <div class="col-md-4">
                                <label for="nmonth">Number of Months</label>
                                <input type="number" class="form-control" placeholder="Enter Scheme Number of Months" value={schememonth} onChange={(e) => setschememonth(e.target.value)} />
                            </div>


                            <div class="col-md-4">
                                <label for="ncer">Number of Certificate</label>
                                <input type="number" class="form-control" placeholder="Enter Scheme Number of Certificate" value={schemecertificate} onChange={(e) => setschemecertificate(e.target.value)} />
                            </div>


                            <div class="text-center">
                                <button type="button" class="btn btn-primary" onClick={IUDOperation}>Submit</button>
                                <button type="reset" class="btn btn-info">
                                    <Link to='/Scheme'>
                                        Back
                                    </Link>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    )
}
